import component from './AvailableWebsitesInfo.vue'
export default component
